import React from "react";
import { NavLink } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { Trans } from "react-i18next";

interface MenuItem {
  name: string;
  route: string;
  icon?: string;
  iconType?: "SVG" | "MAT";
}

interface SidebarProps {
  menuItems: MenuItem[];
}

const Sidebar: React.FC<SidebarProps> = ({ menuItems }) => {
  const hasPermission = (permission?: string) => {
    //TODO  implementation  ya kuchecki permissions
    return true;
  };

  const { theme } = useTheme();

  return (
    <div
      className={`flex flex-col p-4 ${
        theme === "night" ? "bg-gray-700 text-gray-50" : "bg-primary-100 "
      }`}
    >
      {menuItems.map((menu, index) =>
        hasPermission(menu.name) ? (
          <NavLink
            key={index}
            to={menu.route}
            className={({ isActive }) => `
                            flex items-center gap-3 px-4 py-2 rounded-l-full cursor-pointer
                            ${
                              isActive
                                ? theme === "night"
                                  ? "bg-gradient-to-r from-primary-500 to-gray-700 text-gray-200"
                                  : "bg-gradient-to-r from-primary-300 to-primary-100"
                                : `hover:${
                                    theme === "night"
                                      ? "bg-gradient-to-r from-gray-500 to-gray-700"
                                      : "bg-gradient-to-r from-primary-300 to-primary-100"
                                  }`
                            }
                        `}
          >
            {menu.icon && menu.iconType === "MAT" && (
              <span className="material-icons text-lg">{menu.icon}</span>
            )}
            <span className="text-sm font-medium hidden sm:inline">
              <Trans>{menu.name}</Trans>
            </span>
          </NavLink>
        ) : null
      )}
    </div>
  );
};

export default Sidebar;
